<template>
  <div>
    <FormGroup
      spacing="sm"
      :prop="`${prefix}_address_country_code`"
      :label="$t(`${translationBasePath}country_code.label`)"
      :floating-label="floatingLabel"
      :input-value="value"
    >
      <CountrySelect
        v-bind="$attrs"
        v-on="$listeners"
        :value="value"
        :name="`${prefix}_address_country_code`"
        :data-test="`${prefix}_address_country_code`"
        :id="`invoice_${prefix}_attributes_address_attributes_country_code`"
        :prefix="prefix"
        @update:selectedCountry="updateSelectedCountry"
        :floating-label="floatingLabel"
      />
    </FormGroup>
    <FormGroup
      v-if="showSubdivision"
      spacing="sm"
      :prop="`${prefix}_address_subdivision`"
      :label="$t(`${translationBasePath}subdivision.label`)"
      :floating-label="floatingLabel"
      has-input-value
    >
      <CountrySubdivisionSelect
        :name="`${prefix}_address_subdivision`"
        :data-test="`${prefix}_address_subdivision`"
        :id="`${prefix}_attributes_address_attributes_subdivision`"
        :prefix="prefix"
        :country="value"
        :value="subdivision"
        @change="updateSelectedSubdivision"
        :floating-label="floatingLabel"
      />
    </FormGroup>
  </div>
</template>

<script>
import CountrySelect from './CountryField/CountrySelect.vue';
import CountrySubdivisionSelect from './CountryField/CountrySubdivisionSelect.vue';

const translationMap = {
  seller: 'form.invoiceForm.fields.seller_address_',
  buyer: 'form.invoiceForm.fields.buyer_address_',
  contact: 'contacts.fields.',
};

export default {
  components: {
    CountrySelect,
    CountrySubdivisionSelect,
  },
  props: {
    floatingLabel: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    subdivision: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    selectedCountry: null,
    ignoreFirstWatchTrigger: true,
  }),
  computed: {
    showSubdivision() {
      return this.selectedCountry?.subdivisions;
    },
    translationBasePath() {
      return translationMap[this.prefix] || '';
    },
  },
  methods: {
    updateSelectedCountry(country) {
      this.selectedCountry = country;
      this.$emit('update:country', country.key);
    },
    updateSelectedSubdivision(subdivision) {
      this.$emit('update:subdivision', subdivision);
    },
  },
  watch: {
    value(newCountry, oldCountry) {
      if (this.ignoreFirstWatchTrigger) {
        this.ignoreFirstWatchTrigger = false;
      } else if (newCountry !== oldCountry) {
        this.$emit('update:subdivision', '');
      }
    },
    showSubdivision(val) {
      this.$emit('show-subdivision', val);
    },
  },
};
</script>
